var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"profile-section"},[_c('div',{on:{"click":_vm.clicked}},[_c('Breadcrumb',{attrs:{"items":_vm.breadCrumbs}})],1),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }